<template>
  <div>
    <van-nav-bar title="发票管理" right-text="申请发票" left-arrow
                 @click-left="$router.push('/home')"
                 @click-right="$router.push('/invoice/edit')" />
    <my-company />
    <van-search v-model="queryCondition.payer" show-action placeholder="请输入开票抬头" @search="query">
      <template #action>
        <div @click="query">搜索</div>
      </template>
    </van-search>
    <template v-for="row in data">
      <van-swipe-cell>
        <van-cell size="large" is-link @click="handleModify(row)">
          {{ row.amount | toThousandFilter }}
          <template #title>
            <span class="custom-title">{{ row.type | fmConst('INVOICE_TYPE') }}</span>
            <van-tag :type="row.status === 1 ? 'danger' : row.status === 2 ? 'warning' : 'success'">
              {{ row.status | fmConst('INVOICE_STATUS') }}
            </van-tag>
          </template>
          <template #label>
            <div>{{ row.payer }}</div>
          </template>
        </van-cell>
        <template #right>
          <van-button square type="danger" text="删除" @click="handleDel(row)" class="delete-button" />
        </template>
      </van-swipe-cell>
    </template>
  </div>
</template>

<script>
import { getInvoiceList, deleteInvoice } from '@/api/invoice'
import MyCompany from '@/components/commons/my-company'
import ChangeYm from '@/components/commons/change-ym'
import { mapGetters } from 'vuex'
export default {
  components: { MyCompany, ChangeYm },
  data() {
    return {
      data: [],
      queryCondition: {
        payer: ''
      }
    }
  },
  computed: {
    ...mapGetters(['currClient'])
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      getInvoiceList({
        payer: this.queryCondition.payer,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'desc',
        client_name: this.currClient.client_name
      }).then(resp => {
        this.data = resp.rows || []
      })
    },
    handleModify(row) {
      this.$store.dispatch('invoice/setInvoice', row)
      this.$router.push('/invoice/edit')
    },
    handleDel(row) {
      if (row.status !== 1) {
        this.warning('只允许删除待开票状态的记录')
      } else {
        this.confirm(`确定删除【${ row.payer }】发票申请吗？`).then(() => {
          deleteInvoice({
            id: row.id
          }).then(resp => {
            this.success(resp.msg)
            this.query()
          })
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/invoice/list.vue